
export const ImageOverlay = {
    withText: (text: string) => ({
        withSetter: (setter: (img?: string) => void) => ({
            call: async (base64: string | null): Promise<void> => {
                if (!!base64) {
                    const img = new Image();

                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        const context = canvas.getContext('2d');

                        // match image size
                        canvas.width = img.width;
                        canvas.height = img.height;

                        // add image to canvas
                        context?.drawImage(img, 0, 0, canvas.width, canvas.height);

                        // add text
                        if (context) {
                            //overlay behind text
                            context.fillStyle = "rgba(0, 0, 0, 0.3)"
                            context.fillRect(0, canvas.height - 30, canvas.width, 30);

                            //text
                            context.font = '16px Arial';
                            context.fillStyle = '#a8f720';
                            context.strokeStyle = 'black';
                            context.lineWidth = 0.5;

                            const posX = 12;
                            const posY = canvas.height - 8;
                            context.fillText(text, posX, posY);
                            context.strokeText(text, posX, posY);
                        }

                        setter(canvas.toDataURL('image/jpeg'));
                    };

                    img.src = base64;
                } else {
                    setter(undefined);
                }
            }
        })
    })
};